import { Typography } from '@hermes/web-components'
import React from 'react'
import useTranslateMessage from '@hooks/useTranslateMessage'
import { NoSellersFoundContainer } from './NoSellersFound.styles'

const NoSellersFound = () => {
  const { t } = useTranslateMessage()
  return (
    <NoSellersFoundContainer>
      <Typography variant="h3">{t({ id: 'noSellersYet.title' })}</Typography>
      <Typography>{t({ id: 'noSellersYet.subtitle' })}</Typography>
    </NoSellersFoundContainer>
  )
}

export default NoSellersFound
